import { Customer } from "@/models/customer";
import { ShoppingCart } from "@/models/shopping";

export default class SessionService {
  public static STORAGE_KEY_CUSTOMER: string = "qorus_customer";

  public static saveCustomer(customer: Customer | null): void {
    if (customer != null) {
      localStorage.setItem(this.STORAGE_KEY_CUSTOMER, JSON.stringify(customer));
    } else {
      localStorage.removeItem(this.STORAGE_KEY_CUSTOMER);
    }
  }

  public static getCustomer(): Customer | null {
    const storageCustomer = localStorage.getItem(this.STORAGE_KEY_CUSTOMER);

    if (!storageCustomer) {
      return null;
    }

    return JSON.parse(storageCustomer) as Customer;
  }

  public static saveShoppingCart(shoppingCart: ShoppingCart | null): void {
    const customer = this.getCustomer();

    if (customer != null) {
      customer.shoppingCart = shoppingCart;
    }

    this.saveCustomer(customer);
  }
}